import { Component, HostListener, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { RoutePathEnum } from '@shared/enums'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { SidebarRouteConst } from '@shared/constants'
import { SidebarRouteModel } from '@shared/model/inbetween/sidebar-rotues.model'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, FontAwesomeModule, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.sass',
})
export class SidebarComponent {
  routePathEnum = RoutePathEnum
  faUser = faUser
  loggerId: string = 'ac463c2d-ea46-4507-ad96-5aff380d6314'
  sidebarRoutes: SidebarRouteModel[] = SidebarRouteConst
  isSmallScreen: boolean

  @Input() isSidebarOpen: boolean

  constructor() {
    this.isSmallScreen = window.innerWidth <= 768
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isSmallScreen = window.innerWidth <= 768
  }
}
